import prop from 'ramda/src/prop';
import sortBy from 'ramda/src/sortBy';

export const sortByL1Name = sortBy(prop("l1Name"));